module.exports = ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}"


// WEBPACK FOOTER //
// webpack://ClassicEditor/ckeditor5-image/theme/imagecaption.css